var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 2.02199L5.67734 8.68366L3.204 6.21033L4.0265 5.38783L5.67734 7.03866L11.5107 1.20533L12.3332 2.02199ZM11.044 4.96199C11.1198 5.29449 11.1665 5.64449 11.1665 6.00033C11.1665 8.57866 9.07817 10.667 6.49984 10.667C3.9215 10.667 1.83317 8.57866 1.83317 6.00033C1.83317 3.42199 3.9215 1.33366 6.49984 1.33366C7.4215 1.33366 8.27317 1.60199 8.9965 2.06283L9.8365 1.22283C8.8915 0.557826 7.74234 0.166992 6.49984 0.166992C3.27984 0.166992 0.666504 2.78033 0.666504 6.00033C0.666504 9.22033 3.27984 11.8337 6.49984 11.8337C9.71984 11.8337 12.3332 9.22033 12.3332 6.00033C12.3332 5.30616 12.2048 4.64116 11.9832 4.02283L11.044 4.96199Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/doneIcon.c5df3a1b2f12d7b9185aa0f4db18e7b7.svg";
export { ForwardRef as ReactComponent };